import { render, staticRenderFns } from "./ListSubMenu.vue?vue&type=template&id=1e35bd53&"
import script from "./ListSubMenu.vue?vue&type=script&lang=js&"
export * from "./ListSubMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports